import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Centralized global type definitions for Google Analytics
declare global {
    interface Window {
        dataLayer: any[];
    }
}

function PageViewTracker() {
    const location = useLocation();

    useEffect(() => {
        // For a Single Page App, we push a custom event to the dataLayer, which GTM will listen for.
        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'virtual_page_view',
                page_path: location.pathname + location.search,
            });
        }
    }, [location]);

    return null; // This component does not render anything
}

export default PageViewTracker;